import { Target, ShieldCheck, Send, ArrowUpRight } from "lucide-react";

const STAGES = [
    {
        icon: Target,
        title: "Launch & Targeting",
        body: "Campaigns launch across your chosen micro-market with creative tailored to buyer intent signals — property type, budget band and purchase timeline.",
    },
    {
        icon: ShieldCheck,
        title: "AI Qualification",
        body: "Every enquiry is assessed against key buyer-intent signals, so your sales team knows which conversations to prioritize first.",
    },
    {
        icon: Send,
        title: "Delivery & Iteration",
        body: "Qualified enquiries are delivered to your CRM or WhatsApp in real time, with campaigns continuously refined using actual performance data.",
    },
];

const WA_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "917836874807";

export default function CaseStudies() {
    const waHref = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(
        "Hi Lead Krafts, I'd like to understand how a campaign would run for my project."
    )}`;

    return (
        <section
            id="process"
            data-testid="case-studies-section"
            className="py-24 sm:py-32 px-6 sm:px-10 lg:px-16 border-t border-white/5"
        >
            <div className="max-w-7xl mx-auto">
                <div className="max-w-2xl mb-16">
                    <div className="flex items-center gap-3 mb-6">
                        <div className="h-px w-10 bg-[#D4AF37]" />
                        <span className="overline">How We Work</span>
                    </div>
                    <h2 className="font-serif-display text-4xl sm:text-5xl tracking-tight leading-[1.05]">
                        What a well-run campaign <span className="italic text-[#D4AF37]">typically looks like</span>.
                    </h2>
                    <p className="mt-6 text-white/60 max-w-lg">
                        A general overview of how our campaigns run — from launch through to delivery. No
                        fabricated numbers, just the process.
                    </p>
                </div>

                <div className="grid md:grid-cols-3 gap-4" data-testid="case-studies-grid">
                    {STAGES.map((s, i) => (
                        <div key={s.title} data-testid={`case-${i}`} className="hol-card p-8">
                            <div className="h-11 w-11 grid place-items-center border border-[#D4AF37]/40 text-[#D4AF37]">
                                <s.icon size={20} strokeWidth={1.5} />
                            </div>
                            <div className="mt-6 overline !text-white/40">Stage {String(i + 1).padStart(2, "0")}</div>
                            <h3 className="mt-2 font-serif-display text-2xl leading-tight">{s.title}</h3>
                            <p className="mt-4 text-sm text-white/60 leading-relaxed">{s.body}</p>
                        </div>
                    ))}
                </div>

                <div className="mt-12 flex items-center justify-between flex-wrap gap-4 border-t border-white/10 pt-8">
                    <p className="text-sm text-white/50">
                        Want to see how this would work for your project?
                    </p>
                    <a
                        href={waHref}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="cases-cta"
                        className="btn-outline-gold text-sm"
                    >
                        Talk to a Lead Expert <ArrowUpRight size={14} />
                    </a>
                </div>
            </div>
        </section>
    );
}
